"use client";
import { Container, Row, Accordion, Col, Button } from "react-bootstrap";
import Link from "next/link";
import "../../styles/CustomCss/privacy.css";
export default function InspectNAUPrivacyPolicy() {
  return (
    <>
      <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container fluid>
          <Row className="text-start">
            <Row
              className=" pt-5 pb-5 text-center"
              style={{
                backgroundImage: "url(/Images/inner-page-banner.png)",
                backgroundRepeat: "no-repeat",
                backgroundSize: " cover",
                backgroundPosition: " 0px center",
                margin: " 0px",
                height: " 290px",
              }}
            >
              <div className="col-md-2 col-12"></div>

              <div className="col-md-8 col-12">
                <h1
                  className="BiEmpowering"
                  style={{
                    color: "rgb(5, 81, 96)",
                    paddingTop: " 70px",
                    textAlign: " center",
                  }}
                >
                  InspectNAU Privacy Policy
                </h1>
                <h3
                  style={{
                    color: " rgb(5, 81, 96)",
                    paddingTop: " 10px",
                    textAlign: " center",
                  }}
                >
                  <i>Last updated: 01st Jan 2026 | Orion Marine Concepts</i>

                </h3>
              </div>

              <div className="col-md-2 col-12"></div>
            </Row>
          </Row>
        </Container>
        <Container>
          <Row className="text-start">
            <Col xs={12} md={2}></Col>
            <Col xs={12} md={8}>
             
            <section class="privacy-page">
    <div class="privacy-container">


     
        <div class="privacy-intro">
            <p>
                Your privacy matters to us. This policy explains what information
                InspectNAU collects, why, and how it's kept safe. We've kept it
                short on purpose — if anything is unclear, contact us at
                <a href="mailto:helpdesk@orionmarineconcepts.com">
                    helpdesk@orionmarineconcepts.com
                </a>.
            </p>
        </div>

        
        <div class="privacy-content">

           
            <section class="privacy-section">
                <h2>1. Information We Collect</h2>

                <div class="privacy-item">
                    <h3>Account information</h3>
                    <p>
                        Your name, email address provided when you register,
                        company name, designation, and WhatsApp number as
                        desired within the profile.
                    </p>
                </div>

                <div class="privacy-item">
                    <h3>Device information</h3>
                    <p>
                        A device identifier, device name, and platform
                        (iOS/Android) for each device you register. InspectNAU
                        allows up to <strong>2 devices per account</strong>,
                        and this information is what lets us manage that.
                    </p>
                </div>

                <div class="privacy-item">
                    <h3>Inspection and checklist data</h3>
                    <p>
                        The inspections, audits, and checklists you create
                        or upload, including any custom checklists you bring
                        into the app. This is stored on your device for
                        offline use.
                    </p>
                </div>

                <div class="privacy-item">
                    <h3>Subscription information</h3>
                    <p>
                        Your subscription status and plan type. Payment itself
                        is handled entirely by the Apple App Store or Google
                        Play Store — InspectNAU never sees or stores your
                        card details.
                    </p>
                </div>
            </section>

           
            <section class="privacy-section">
                <h2>2. How We Use Your Information</h2>

                <p>
                    We use your information to operate the app, manage your
                    account and registered devices, confirm your subscription
                    status, provide support, and meet legal obligations.
                    If your account is connected to a company or fleet, your
                    organization's administrators may be able to view inspection
                    data associated with that account through our fleet dashboard.
                </p>
            </section>

           
            <section class="privacy-section">
                <h2>3. Offline Use, Storage &amp; Security</h2>

                <p>
                    InspectNAU is built to work fully offline. Your data is
                    stored securely on your device and synchronised to our
                    server once online. We retain your information only as
                    long as needed to provide the service or as required
                    by law.
                </p>
            </section>

            
            <section class="privacy-section">
                <h2>4. Third-Party Services</h2>

                <p>
                    Subscriptions are billed and managed by the Apple App Store
                    or Google Play Store under their own respective privacy
                    policies. We use their standard notification systems to
                    confirm your subscription status. We do not sell your
                    personal data to third parties.
                </p>
            </section>

           
            <section class="privacy-section">
                <h2>5. Your Rights</h2>

                <p>
                    You can request access to, correction of, or deletion of
                    your personal data at any time by contacting us. If you're
                    in the European Economic Area or another region with data
                    protection laws such as the GDPR, you have the right to
                    lodge a complaint with your local data protection authority.
                </p>
            </section>

           
            <section class="privacy-section">
                <h2>6. Children's Privacy</h2>

                <p>
                    InspectNAU is intended for professional use by maritime
                    inspectors and auditors. It is not directed at children,
                    and we do not knowingly collect personal data from anyone
                    under 16.
                </p>
            </section>

           
            <section class="privacy-section">
                <h2>7. Changes to This Policy</h2>

                <p>
                    We may update this policy from time to time. Continued use
                    of InspectNAU after a change means you accept the updated
                    policy. Material changes will be noted with a new
                    <strong>"Last updated"</strong> date above.
                </p>
            </section>

            
            <section class="privacy-section privacy-contact">
                <h2>8. Contact Us</h2>

                <div class="contact-details">
                    <p>
                        <strong>Orion Marine Concepts</strong>
                    </p>

                    <p>
                        Email:
                        <a href="mailto:helpdesk@orionmarineconcepts.com">
                            helpdesk@orionmarineconcepts.com
                        </a>
                    </p>
                </div>
            </section>

        </div>

    </div>
</section>

            </Col>
            <Col xs={12} md={2}></Col>
          </Row>
        </Container>
        <Container fluid style={{ padding: "0" }} className=" m-t-40 text-left">
          <Row style={{ margin: "0", padding: "0" }}>
            <Row
              className=" pt-5 pb-5 text-center"
              style={{
                backgroundImage: "url(/Images/Nau/CrossPattern.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "0",
                margin: "0",
              }}
            >
              <Col xs={12} md={8}>
                <h1
                  className="BiEmpowering"
                  style={{ color: "#ffffff", paddingTop: "3%" }}
                >
                  Ready to Sail?{" "}
                </h1>
                <h1
                  className="BiEmpoweringBottomText"
                  style={{ color: "#ffffff", paddingTop: "3%" }}
                >
                  Set sail on a journey that redefines efficiency and ushers in
                  a new era in maritime management. Join the NAU 2.1 wave today.{" "}
                </h1>
              </Col>
              <Col xs={12} md={4}>
                <Button
                  variant="light"
                  className="m-t-90 p-l-50 p-r-50 fs-25 p-t-10 p-b-10 btn btn-light"
                >
                  <Link href="/ScheduleDemo" style={{ fontSize: "1.4rem" }}>
                    Embark Now
                  </Link>
                </Button>
              </Col>
            </Row>
          </Row>
        </Container>
      </Row>
    </>
  );
}
